/**
 * Extracts the alley identifier from a filename.
 * The alley is expected to be in the format of "AxB" where A and B are numbers,
 * separated by "x", like "1x2" in "A100-NCI-NCIRanch-NCIBlock-1x2-left_2025-03-21-18-33-59.bag"
 *
 * @param fileName - The filename to extract the alley from
 * @returns The alley string if found, null otherwise
 */
export const extractAlleyFromFilename = (fileName?: string): string | null => {
  if (!fileName) return null;

  // Find a pattern with numbers separated by 'x'
  // This matches patterns like '1x2', '10x5', etc.
  const alleyPattern = /(\d+)x(\d+)/;
  const match = fileName.match(alleyPattern);

  if (match && match[0]) {
    return match[0]; // Return the full match (e.g., "1x2")
  }

  return null;
};
